
<div class="ttmodal">
    <div class="ttmodal__header">
    </div>
    <div class="ttmodal__body" style="width: max-content">
        <span >{{'Do you want to attach Temperature Inspection to the Report? ' | translate | async}}</span>
    </div>

    <div class="ttmodal__footer" style="display: flex;flex-direction: row;justify-content: space-evenly;">
        <button mat-raised-button (click)="onNoClick()">{{'No'| translate | async}}</button>
        <button mat-raised-button color="warn" (click)="onYesClick()"><span
            class="button__text">{{'Yes'| translate | async}}</span></button>
      </div>
  </div>